<template>
  <div v-bem="{rtl: $i18n.locale === 'ar'}" class="conatiner">
    <div
      v-bem:item
      v-for="model in $store.state.models"
      :key="'model'+model.id"
    >
      <div v-bem:box>
        <p v-bem:name>{{model.nom}}</p>
        <img v-bem:image :src="model.image" :alt="model.nom">
        <p v-bem:price v-if="isInStock(model) && showPrices">{{$t('currency.starting')}}<span>{{minPrice(model.voitures)}} <sub> DHS TTC</sub></span></p>
        <button
          v-if="!showPrices"
          class="button button--primary"
          @click="showForm(model)"
        >
          <span class="button__text">{{!isInStock(model) ? $t('cta.out-of-stock') : $t('cta.showPriceModel')}}</span>
        </button>
        <button
          v-else
          class="button button--primary"
          @click="selectModel(model)"
        ><span class="button__text">{{isInStock(model) ? $t('cta.want-it') : $t('cta.out-of-stock')}}</span></button>
        <p class="unavailable-text" v-if="!isInStock(model)">{{$t('steps.version.unavailableText')}}</p>
      </div>
    </div>
  </div>
</template>

<script>
import EventBus from '@/event-bus'

export default {
  name: 'Models',
  data: () => ({
    showPrices: false
  }),
  methods: {
    showForm(model) {
      this.$store.dispatch('setModel', model)
      this.$emit('show-form')
    },
    minPrice(versions) {
      const prices = versions.filter(({stock_epuise}) => !stock_epuise).map(({prix}) => prix)
      return prices.length ? this.priceFormat(Math.min(...prices)) : ''
    },
    selectModel(model) {
      if (this.isInStock(model)) {
        this.$store.dispatch('setModel', model);
        this.$router.replace(`/${this.$i18n.locale}/commande/${model.nom_lien.toLowerCase()}`);
        this.$emit('next-step');
      } else this.showForm(model)
    },
    isInStock(model) { return !model.stock_epuise && model.voitures.length > 0 },
  },
  mounted() {
    EventBus.$on('form-submited', () => this.showPrices = true)
  },
  created() {
    if (this.$store.getters.trade) this.showPrices = true
    else {
      let storeUser = localStorage.getItem('storeUser')
      storeUser = storeUser ? JSON.parse(storeUser) : { id: '' }
      this.showPrices = storeUser.id !== ''
    }
  }
}
</script>

<style scoped lang="scss">
.models {
  position: relative;
  max-width: rem(1280);
  margin: 0 auto;
  padding-bottom: rem(30);
  text-align: center;
  &__item {
    display: inline-block;
    margin: rem(30) auto;
    width: calc(100% / 3);
    @include breakpoint(960) {
      width: 50%;
    }
    @include breakpoint(560) {
      width: 100%;
    }
  }
  &__name {
    position: relative;
    display: inline-block;
    @include font-size(20);
    font-family: var(--primary-font-bold);
    text-transform: uppercase;
  }
  &__image {
    display: table;
    max-width: rem(280);
    margin: rem(10) auto;
  }
  &__price {
    text-transform: uppercase;
    margin-bottom: rem(20);
    span {
      display: block;
      font-family: var(--primary-font-bold);
      color: rgba(var(--primary-color), 1);
      @include font-size(26);
      sub {
        vertical-align: initial;
        @include font-size(18);
      }
    }
  }
  .unavailable-text {
    @include font-size(12);
    max-width: rem(220);
    margin: rem(8) auto;
    color: $dark-gray;
  }
  &--rtl {
    .models__price {
      span {
        direction: ltr;
      }
    }
    .models__name {
      &::before {
        left: initial;
        right: rem(-40);
      }
    }
  }
}
</style>